/**
 * Checks if provided array is empty
 */
export const isEmpty = (array: any[] | string): boolean => (!array?.length)